export default [{
        path: '/privacy',
        name: 'privacy',
        component: () =>
            import ('@/views/pages/privacy/PrivacyPolicy.vue'),
        meta: {
            pageTitle: 'Privacy policy',
            layout: 'full',
            resource: 'Auth',
            action: 'read'
        }
    },
    {
        path: '/cookies',
        name: 'cookies',
        component: () =>
            import ('@/views/pages/privacy/CookiesPolicy.vue'),
        meta: {
            pageTitle: 'Cookies policy',
            layout: 'full',
            resource: 'Auth',
            action: 'read'
        }
    }
]